import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import services from '@/services/services.js'
import pricing from '@/data/pricing.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!Cookies.get('TB_SESSION'),
    tb4t: !!Cookies.getJSON('TB_SESSION') && Cookies.getJSON('TB_SESSION').tb4t,
    userData: {},
    billingData: {},
    pricingData: pricing,
    recieved: {
      billing: false,
      user: false,
      pricing:false,
      team:false,
      pending:false
    },
    toRoute: {},
    activeUser: false,
    submitting: false,
    modalOpen: false,
    userDataRequested: false,
    teamData: {},
    pendingData: [],
    newTeam: {
      inviteCount: 0
    },
    domain: ''
  },
  mutations: {
    checkLoggedInState (state) {
      state.isLoggedIn = !!Cookies.get('TB_SESSION')
    },
    userData (state, data) {
      state.userData = data
      state.tb4t = data.teamRole || ''
      state.recieved.user = true
    },
    billingData (state, data) {
      state.billingData = data
      state.recieved.billing = true
    },
    setPricing (state, data) {
      state.pricingData = data
      state.recieved.pricing = true
    },
    saveNextRoute (state, data) {
      state.toRoute = data
    },
    destroyNextRoute (state) {
      state.toRoute = null
    },
    login (state) {
      state.isLoggedIn = true
    },
    logout (state) {
      state.isLoggedIn = false
    },
    submitting (state, submitting) {
      state.submitting = submitting
    },
    modalOpen (state, status) {
      state.modalOpen = status
    },
    userDataRequested (state) {
      state.userDataRequested = true
    },
    activeUser (state) {
      state.activeUser = true
    },
    teamData (state, data) {
      state.teamData = data
      state.recieved.team = true
    },
    tempTeamDetails (state, data) {
      if (data.teamName) state.teamData.teamName = data.teamName
      if (data.teamRole) state.teamName = data.teamRole
    },
    pendingData (state, data) {
      state.pendingData = data
      state.recieved.pending = true
    },
    newTeamDetails (state, data) {
      Object.assign(state.newTeam, data)
    },
    newTeamInviteCount (state, n) {
      state.newTeam.inviteCount = n
    },
    domain (state, domain) {
      state.domain = domain
    }
  },
  actions: {
    saveNextRoute ({ commit }, route) {
      commit('saveNextRoute', route)
    },
    getNextRoute ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.toRoute && state.toRoute.name) {
          let toRoute = state.toRoute
          commit('destroyNextRoute')
          resolve(toRoute)
        } else {
          reject()
        }
      })
    },
    changeEmail ({ commit }, email) {
      commit('pendingEmail', email)
    },
    submitting ({ commit }, submitting) {
      commit('submitting', submitting)
    },
    getBillingData ({ commit, state }, forceRefresh) {
      return new Promise((resolve, reject) => {
        let returnExistingData = state.recieved.billing && !forceRefresh
        if (!state.isLoggedIn || returnExistingData) {
          resolve()
        } else {
          this.$http.get(this.ENV.coreBaseUrl + '/team/getBillingDetails').then((response) => {
            commit('billingData', response.data)
            resolve()
          }).catch((err) => {
            if (err.response.status === 403) {
              commit('logout')
            }
            reject()
          })
        }
      })
    },
    newTeamDetails ({ commit }, data) {
      commit('newTeamDetails', data)
    },
    newTeamInviteCount ({ commit }, n) {
      commit('newTeamInviteCount', n)
    },
    getTeamData ({ commit, state }, forceRefresh) {
      return new Promise((resolve, reject) => {
        let returnExistingData = state.recieved.team && !forceRefresh
        if (!state.isLoggedIn || returnExistingData) {
          resolve()
        } else {
          this.$http.get(this.ENV.coreBaseUrl + '/team').then((response) => {
            commit('teamData', response.data)
            resolve()
          }).catch((err) => {
            if (err.response.status === 403) {
              commit('logout')
            }
            reject()
          })
        }
      })
    },
    getPendingData ({ commit, state }, forceRefresh) {
      return new Promise((resolve, reject) => {
        let returnExistingData = state.recieved.pending && !forceRefresh
        if (!state.isLoggedIn || returnExistingData) {
          resolve()
        } else {
          this.$http.get(this.ENV.coreBaseUrl + '/team/pending').then((response) => {
            commit('pendingData', response.data)
            resolve()
          }).catch(() => {
            reject()
          })
        }
      })
    },
    async getUserData ({ commit, state }, forceRefresh) {
      const returnExistingData = state.recieved.user && !forceRefresh
      if (!state.isLoggedIn || returnExistingData) return
      try {
        const response = await this.$http.get(this.ENV.coreBaseUrl + '/api/getUserDetails')
        commit('userData', response.data)
        commit('userDataRequested')
      } catch (err) {
        if (err.response.status === 403) {
          commit('logout')
        }
        commit('userDataRequested')
        throw err
      }
    },
    getPricingData ({ commit, state }, couponCode) {
      return new Promise((resolve, reject) => {
        if (state.recieved.pricing) {
          resolve()
        } else {
          this.$http.get(this.ENV.coreBaseUrl + '/api/getPricingDetails', {
            'params': { couponCode: couponCode }
          }).then((response) => {
            commit('setPricing', response.data)
            resolve()
          }).catch((e) => {
            reject()
          })
        }
      })
    },
    loginSignup ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        this.$http.post(this.ENV.coreBaseUrl + '/loginCreate', data).then((response) => {
          if (response.data.result === 'OK' || response.data.result === 'PASS') {
            if (response.data.details.teamName) {
              commit('tempTeamDetails', response.data.details)
            }
            commit('login')
            dispatch('getUserData', true)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    async login ({ commit, dispatch }, data) {
      const passwordLoginData = {
        password: data.password,
        username: data.username,
        grant_type: 'password',
        device: `browser-${process.IS_TEST ? 'test-id' : self.crypto.randomUUID()}`
      }
      const tokenApiUrl = this.ENV.dashboardBaseUrl + '/v2/token'
      const tokenResponse = await this.$http.post(tokenApiUrl, passwordLoginData, {
        headers: { 'Content-Type': 'application/json' }
      })
      await this.$http.post(this.ENV.dashboardBaseUrl + '/v2/tokenCookie', {}, {
        headers: { 'Authorization': `Bearer ${tokenResponse.data.access_token}` }
      })
      await dispatch('getUserData', true)
      commit('login')
    },
    createAccount ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        this.$http.post(this.ENV.coreBaseUrl + '/createAccount', data).then((response) => {
          if (response.data.result === 'OK') {
            commit('login')
            dispatch('getUserData', true)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    logout ({ commit, dispatch, state }) {
      commit('checkLoggedInState')
      return new Promise((resolve, reject) => {
        if (!state.isLoggedIn) {
          commit('userData', {})
          resolve()
        } else {
          this.$http.post(this.ENV.coreBaseUrl + '/api/logout', {}).then((response) => {
            if (response.data.result === 'PASS') {
              Cookies.set('tb_user', true, { expires: 7 })
              commit('logout')
              commit('userData', {})
              resolve()
            } else {
              reject()
            }
          }).catch(() => {
            reject()
          })
        }
      })
    },
    modalOpen ({ commit }, status) {
      commit('modalOpen', status)
    },
    activeUser ({ commit }) {
      commit('activeUser')
    },
    validateDomain ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        if (!state.domain) {
          let email = state.userData.user || ''
          let domain = email.slice(email.indexOf('@') + 1, email.length)
          this.$http.get(this.ENV.coreBaseUrl + '/team/validateDomain', {
            params: {
              domain: domain
            }
          }).then((response) => {
            if (response.data.result !== 'FAIL') commit('domain', domain)
            resolve()
          }).catch(() => {
            reject()
          })
        }
      })
    }
  },
  getters: {
    tb4t: state => {
      return state.tb4t
    },
    isLoggedIn: state => {
      return state.isLoggedIn
    },
    userData: state => {
      return state.userData
    },
    teamData: state => {
      return state.teamData
    },
    pendingData: state => {
      return state.pendingData
    },
    userDataRequested: state => {
      return state.userDataRequested
    },
    billingData: state => {
      return state.billingData
    },
    pricingDetails: state => {
      return Object.assign(state.pricingData, {
        'GOTB': {
          'chargePrice': state.pricingData.YEARLY_PAYMENT_RECURRING.salePrice || state.pricingData.YEARLY_PAYMENT_RECURRING.regularPrice,
          'regularPrice': state.pricingData.YEARLY_PAYMENT_RECURRING.regularPrice
        }
      })
    },
    submitting: state => {
      return state.submitting
    },
    saleDetails: state => {
      let saleData = {}
      let yearly = state.pricingData.YEARLY_PAYMENT_RECURRING
      let monthly = state.pricingData.MONTHLY_PAYMENT

      let chargePriceIsSalePrice = (Number(yearly.chargePrice) === Number(yearly.salePrice))
      if (chargePriceIsSalePrice &&
        yearly.salePrice) {
        let savePercent = services.savePercent(yearly.salePrice, monthly.regularPrice)
        Object.assign(saleData, {
          isLive: true,
          tagline: 'Holiday sale. You save ' + savePercent + '%!'
        })
      }
      return saleData
    },
    nextRoute: state => {
      return state.toRoute
    },
    modalOpen: state => {
      return state.modalOpen
    },
    domain: state => {
      return state.domain
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js